import {err} from 'framework';
import type {Result, UseCase, ValidationError} from 'framework';
import type {WorkoutError} from '../../domain/errors';
import type {LogSetResult} from '../../domain/workout';
import type {LogSetInput, WorkoutRepository} from '../ports/workout.repository';
import type {LogSetDataValidator} from '../validators/log-set-data.validator';

export class LogSet implements UseCase<[LogSetInput], LogSetResult> {
  constructor(
    private readonly repository: WorkoutRepository,
    private readonly validator: LogSetDataValidator,
  ) {}

  execute(input: LogSetInput): Promise<Result<LogSetResult, WorkoutError | ValidationError>> {
    const validated = this.validator.validate(input);
    if (!validated.ok) {
      return Promise.resolve(err(validated.error));
    }
    return this.repository.logSet(validated.data);
  }
}
